import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { useContext } from "react";
import LoginForm from "./LoginForm";
import LoginFormV2 from "./LoginFormV2";
import { ProductServerAuthContext } from "../providers/ProductServerAuth";

type LoginDialogProps = {
}

export const LoginDialogV2 = (props: LoginDialogProps) => {

    const { isLoggedIn, isLoginDialogOpen, setLoginDialogOpen, login, logout, loginError } = useContext(ProductServerAuthContext);

    const handleClose = () => {
        setLoginDialogOpen(false);
    }

    return (
        <Dialog
            open={isLoginDialogOpen}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {"SIGN-IN"}
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    x
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <LoginFormV2></LoginFormV2>
            </DialogContent>
        </Dialog>
    )
}